export default __webpack_public_path__ + "img/i-nav-share.20b9cc49.svg";